import { UserContext } from '@application/contexts';
import { useCourierTokenQuery } from '@domain/users';
import { AppBar, Box, Toolbar, useTheme } from '@mui/material';
import { CourierInboxPopupMenu, useCourier, InboxAction } from '@trycourier/courier-react';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import TenantMenu from './TenantMenu';
import UserMenu from './UserMenu';

type CourierToastItemActionClickEvent = {
  action: InboxAction;
};

const TopBar = () => {
  const navigate = useNavigate();

  const { user } = useContext(UserContext);
  const courier = useCourier();
  const { data } = useCourierTokenQuery({ pause: !user });

  useEffect(() => {
    if (!user || !data?.courierToken) return;
    courier.shared.signIn({ userId: user.externalNotificationId, jwt: data.courierToken });
  }, [user, data?.courierToken, courier.shared]);

  // const renderMenuButton = useCallback(() => <Notifications fontSize="small" />, []);

  const { palette, zIndex } = useTheme();

  return (
    <AppBar
      position="sticky"
      variant="outlined"
      sx={{
        top: '0',
        zIndex: zIndex.appBar,
        background: palette.common.white,
        border: 'none',
        borderBottom: `1px solid ${palette.divider}`,
        '.MuiToolbar-root': { minHeight: 'var(--top-bar-height)' },
      }}
      elevation={0}
    >
      <Toolbar disableGutters sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginX: 3 }}>
        {user && (
          <>
            <TenantMenu />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <CourierInboxPopupMenu
                popupAlignment="top-right"
                lightTheme={{
                  inbox: {
                    header: { backgroundColor: 'white' },
                    list: {
                      backgroundColor: 'white',
                      item: { unreadIndicatorColor: '#FF2700' },
                    },
                  },
                }}
                onMessageActionClick={({ action }: CourierToastItemActionClickEvent) => {
                  if (action.href) {
                    navigate(action.href);
                  }
                }}
              />

              <UserMenu />
            </Box>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};
export default TopBar;
